import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import HealthCheckRow from './HealthCheckRow'

const STATUS_BADGES = {
	ok: 'bg-success',
	warning: 'bg-warning',
	error: 'bg-danger',
	skipped: 'bg-secondary',
}

// Карточка блока проверок: «Фискализация — 7 из 9».
//
// Блоки с ошибкой раскрыты сразу: красное не должно прятаться за кликом. Остальные
// свёрнуты — иначе страница с пятью интеграциями превращается в простыню.
//
// Тот же компонент встраивается в страницу настройки (карточку интеграции, терминалы):
// данные туда приходят из /setup-health/{key}.
function HealthModuleCard({ module, defaultOpen = null, children }) {
	const { t } = useTranslation()

	const [isOpen, setIsOpen] = useState(defaultOpen !== null ? defaultOpen : module.status === 'error')

	// Порядок как отдал бэк — это шаги настройки: услуга, точка, ключи, меню, и только потом
	// то, что зависит от кассы. Сортировка «ошибки вперёд» перемешивала шаги, и список
	// переставал читаться как инструкция
	const checks = module.checks || []

	const title = module.title || t(`setup_health_module_${module.key}`)

	return (
		<div className="card mb-3">
			<div className="card-body">
				<div className="d-flex justify-content-between align-items-center cursor-pointer"
					onClick={() => setIsOpen(!isOpen)}>
					<div className="d-flex align-items-center">
						<span className={`badge ${STATUS_BADGES[module.status] || STATUS_BADGES.skipped} me-2`}>
							{module.count_ok}/{module.count_total - module.count_skipped}
						</span>

						<h6 className="mb-0">{title}</h6>

						{module.count_error > 0 &&
							<span className="ms-2 text-danger fs-6">
								{t('setup_health_errors', { count: module.count_error })}
							</span>
						}

						{module.count_error === 0 && module.count_warning > 0 &&
							<span className="ms-2 text-warning fs-6">
								{t('setup_health_warnings', { count: module.count_warning })}
							</span>
						}
					</div>

					<i className={`uil ${isOpen ? 'uil-angle-up' : 'uil-angle-down'} fs-4`}></i>
				</div>

				{isOpen &&
					<div className="mt-3">
						{checks.map((check) => (
							<HealthCheckRow key={check.code} check={check} />
						))}

						{children}
					</div>
				}
			</div>
		</div>
	)
}

export default HealthModuleCard
